const state = {
    attendance: [],
    id: [],
    timerState: [],
    loading: false
};

export default state;